import { EAlert } from '../../types/alert';
import { ITypedReduxAction } from '../../types/redux/actionType';

export interface IAlertPayload {
  type?: EAlert;
  message?: string;
  chatId?: string;
}

export enum EAlertActionTypes {
  Show = 'alert/show',
  Hide = 'alert/hide',
}

export type TAlertActions =
  | ITypedReduxAction<EAlertActionTypes.Show, IAlertPayload | void>
  | ITypedReduxAction<EAlertActionTypes.Hide>;
